import { render, staticRenderFns } from "./VehicleAssignmentEditor.vue?vue&type=template&id=76bff0c8&scoped=true"
import script from "./VehicleAssignmentEditor.vue?vue&type=script&lang=js"
export * from "./VehicleAssignmentEditor.vue?vue&type=script&lang=js"
import style0 from "./VehicleAssignmentEditor.vue?vue&type=style&index=0&id=76bff0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bff0c8",
  null
  
)

export default component.exports